import posthog from 'posthog-js'

const config = (window.LaraVue && window.LaraVue.posthog) || {}

export const isEnabled = Boolean(config.key)

export const TRIAL_EXPERIMENT_FLAG = config.trialExperimentFlag

export const CONTROL = 'control'

export const TEST = 'test'

export function initPostHog() {
    if (!isEnabled) return

    posthog.init(config.key, {
        api_host: config.host,
        capture_pageview: 'history_change',
        person_profiles: 'identified_only'
    })

    // Exposes PostHog in the console on non-production sites for debugging.
    if (!LaraVue.app.isProduction) window.posthog = posthog
}

/**
 * Resolves the visitor's variant for an experiment flag.
 *
 * Exposure ($feature_flag_called) is only recorded when the flag is read, which
 * happens once a value is available. When PostHog is disabled, slow or down,
 * the visitor gets the control without being exposed, so they stay out of the
 * results instead of being counted against a variant they never saw.
 */
export function resolveVariant(flag, timeout = 2000) {
    return new Promise(resolve => {
        if (!isEnabled || !flag) return resolve(CONTROL)

        let settled = false
        let unsubscribe = () => {}

        const settle = useFlag => {
            if (settled) return
            settled = true
            clearTimeout(timer)
            unsubscribe()

            const variant = useFlag ? posthog.getFeatureFlag(flag) : undefined

            resolve(variant === TEST ? TEST : CONTROL)
        }

        const timer = setTimeout(() => settle(false), timeout)

        // A returning visitor's flags are cached, so they render with no wait.
        if (posthog.getFeatureFlag(flag, {send_event: false}) !== undefined) return settle(true)

        unsubscribe = posthog.onFeatureFlags((flags, variants, context) => {
            settle(!(context && context.errorsLoading))
        })

        // onFeatureFlags fires synchronously when flags have already loaded.
        if (settled) unsubscribe()
    })
}

/**
 * Records a completed trial registration. Call only once the card has been
 * charged and the account created, so declined or abandoned sign-ups never
 * count as conversions.
 */
export function trackTrialRegistered({user, affiliate, promo}) {
    if (!isEnabled || !user) return

    // Tracking must never turn a successful registration into an error.
    try {
        posthog.identify(String(user.id), {email: user.email})

        posthog.capture('trial_registered', {
            plan: 'trial',
            affiliate: affiliate || null,
            promo: promo || null
        })
    } catch (error) {
        console.error(error)
    }
}

export function resetPostHog() {
    if (isEnabled) posthog.reset()
}
